export const getGraphQlError = (err) => {
  const { message } = err;
  return message.replace('GraphQL error:', '').trim();
};
